<template>
    <base-page class="comp-page-device" :title="$t('l.directions')"
               icon="ios-book">
            <div class="box-explain">
                    <Menu style="width: 40%;" active-name="1" @on-select="select">
                        <MenuGroup :title="$t('l.dty_platform')">
                            <MenuItem name="1">
                                <Icon type="md-document" />
                                {{$t('l.operation_manual')}}
                            </MenuItem>
                            <MenuItem name="2">
                                <Icon type="md-chatbubbles" />
                                {{$t('l.role_res_instructions')}}
                            </MenuItem>
                        </MenuGroup>
                        <MenuGroup :title="$t('l.terminal')">
                            <MenuItem name="3">
                                <Icon type="md-document" />
                                {{$t('l.terminal_operation_manual')}}
                            </MenuItem>
                            <MenuItem name="4">
                                <Icon type="md-document" />
                                {{$t('l.face_operation_manual')}}
                            </MenuItem>
                            <MenuItem name="5">
                                <Icon type="md-document" />
                                {{$t('l.app_operation_manual')}}
                            </MenuItem>
                        </MenuGroup>
                    </Menu>
                    <Card class="margin-left-10 full" :title="$t('l.file')">
                        <ul>
                            <li v-for="elem in getMenus" :key="elem.name" v-if="elem.name == current">
                                <p v-for="(item,index) in elem.fileName" :key="index">
                                    <a class="link-pdf" :href="'https://static.diantiyun.com/'+item">《{{item.substring(0,item.indexOf("."))}}》</a>
                                </p>
                            </li>
                        </ul>
                    </Card>
            </div>
    </base-page>
</template>

<script>

    import BasePage from "../my-components/base-page";
    export default {
        name: "explain",
        components:{BasePage},
        data(){
            return{
                current:'1',
            }
        },
        computed:{
            getMenus(){
                return [
                    {
                        name:1,
                        fileName:['电梯云平台操作手册.pdf',"电梯云物联网推送平台对接配置.pdf"]
                    },
                    {
                        name:2,
                        fileName:['电梯云平台用户与权限管理使用说明.pdf']
                    },
                    {
                        name:3,
                        fileName:[this.$t('l.smart_explain')]
                    },
                    {
                        name:4,
                        fileName:[this.$t('l.face_explain1'),this.$t('l.face_explain2')]
                    },
                    {
                        name:5,
                        fileName:[this.$t('l.dty_app_explain')]
                    },
                ]
            }
        },
        methods:{
            select(name){
                this.current = name;
            }
        }
    }
</script>

<style scoped >
    .box-explain{
        display: flex;
    }
    a:visited{color:#39f;}
</style>